const AUTOMATED_LENDING_DECISION = 'page/AUTOMATED_LENDING_DECISION';
export const AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP = `${AUTOMATED_LENDING_DECISION}_CHANGE_APPLICATION_STEP`;
export const EDIT_ADDITIONAL_GUARANTOR = `${AUTOMATED_LENDING_DECISION}_EDIT_ADDITIONAL_GUARANTOR`;
export const CONTINUE_TO_FINAL_STEP = `${AUTOMATED_LENDING_DECISION}_CONTINUE_TO_FINAL_STEP`;

export const SHOW_CHECKING_APPLICATION = `${AUTOMATED_LENDING_DECISION}_SHOW_CHECKING_APPLICATION`;

export const TAKE_TO_DECISION = `${AUTOMATED_LENDING_DECISION}_TAKE_TO_DECISION`;
